import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import triggerAnalyticsEvent, { Analytics } from '../../../../helpers/analyticsMiddleware';
import { t } from '../../../../strings/i18n/i18n';
import { shallowEqual, useSelector } from 'react-redux';
import DisputesImage from '../../../../ui/atoms/DisputesImage';
import useWindowSize from 'syf-component-library/ui/customHooks/useWindowWidth';
import ContactUs from './ContactUs';
import { ContactFraudImageContainer, Content, Description, Header } from './subcomponents';
var ContactFraud = function () {
    var assetsURL = useSelector(function (state) { return state; }, shallowEqual).mfeConfig.assetsURL;
    var isLessThanTablet = useWindowSize().isLessThanTablet;
    var imageSize = isLessThanTablet ? 'xsmall' : 'small';
    useEffect(function () {
        triggerAnalyticsEvent({
            PageKind: Analytics.Dispute,
            PageFunction: Analytics.Billing,
            PageSubFunction: Analytics.NotRecognized,
            pageName: Analytics.FraudTeam
        });
    }, []);
    return (_jsxs(Content, { children: [_jsx(ContactFraudImageContainer, { children: _jsx(DisputesImage, { assetsHost: assetsURL, imageName: "CONTACT_REP", size: imageSize }) }), _jsx(Header, { children: "".concat(t('contactFraud.title')) }), _jsx(Description, { children: t('contactFraud.description') }), _jsx(Description, { children: t('contactFraud.callUs') }), _jsx(ContactUs, {})] }));
};
export default ContactFraud;
//# sourceMappingURL=index.js.map